<div class="modal fade" id="kt_modal_news_manager_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update News Item' : 'Add News Item' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="newsManagerForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Show Radio Buttons -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Show</label>
              <div class="d-flex gap-5">
                <div class="form-check">
                  <input class="form-check-input" type="radio" formControlName="show" [value]="true" id="show_yes">
                  <label class="form-check-label" for="show_yes">
                    Yes
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" formControlName="show" [value]="false" id="show_no">
                  <label class="form-check-label" for="show_no">
                    No
                  </label>
                </div>
              </div>
              <div *ngIf="show?.invalid && show?.touched" class="invalid-feedback d-block">
                <div *ngIf="show?.errors?.['required']">Show status is required</div>
              </div>
            </div>

            <!-- Image Upload -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Image</label>

              <!-- File Input -->
              <div class="mb-3" *ngIf="!uploadedImageUrl">
                <input
                  type="file"
                  class="form-control form-control-solid"
                  accept="image/*"
                  (change)="onFileSelected($event)"
                  [disabled]="isUploading"
                />
                <div class="form-text">Select an image file (JPG, PNG, GIF)</div>
              </div>

              <!-- Upload Progress -->
              <div *ngIf="isUploading" class="d-flex align-items-center mb-3">
                <div class="spinner-border spinner-border-sm me-2" role="status">
                  <span class="visually-hidden">Uploading...</span>
                </div>
                <span class="text-muted">Uploading image...</span>
              </div>

              <!-- Image Preview -->
              <div *ngIf="uploadedImageUrl && !isUploading" class="border rounded p-3 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="symbol symbol-50px me-3">
                    <div class="symbol-label rounded"
                         [style.background-image]="'url(' + uploadedImageUrl + ')'"
                         style="background-size: cover; background-position: center;">
                    </div>
                  </div>
                  <div>
                    <div class="fw-semibold">Image uploaded successfully</div>
                    <div class="text-muted fs-7">Click remove to change image</div>
                  </div>
                </div>
                <button type="button" class="btn btn-sm btn-light-danger" (click)="removeImage()">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                  Remove
                </button>
              </div>
            </div>

            <!-- Start Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Start Date</label>
              <input
                type="date"
                class="form-control form-control-solid"
                formControlName="start_date"
                [class.is-invalid]="start_date?.invalid && start_date?.touched"
              />
              <div *ngIf="start_date?.invalid && start_date?.touched" class="invalid-feedback">
                <div *ngIf="start_date?.errors?.['required']">Start date is required</div>
              </div>
            </div>

            <!-- Expiry Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Expiry Date</label>
              <input
                type="date"
                class="form-control form-control-solid"
                formControlName="expiry_date"
                [class.is-invalid]="expiry_date?.invalid && expiry_date?.touched"
              />
              <div *ngIf="expiry_date?.invalid && expiry_date?.touched" class="invalid-feedback">
                <div *ngIf="expiry_date?.errors?.['required']">Expiry date is required</div>
              </div>
            </div>

            <!-- News Title -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">News Title</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="news_title"
                placeholder="Enter news title"
                [class.is-invalid]="news_title?.invalid && news_title?.touched"
              />
              <div *ngIf="news_title?.invalid && news_title?.touched" class="invalid-feedback">
                <div *ngIf="news_title?.errors?.['required']">News title is required</div>
                <div *ngIf="news_title?.errors?.['minlength']">News title must be at least 3 characters</div>
              </div>
            </div>

            <!-- News Description (Rich Text Editor) -->
            <div class="col-md-12 mb-5">
              <label class="form-label">News Description</label>
              <app-rich-text-editor
                formControlName="news_description"
                placeholder="Enter news description..."
                height="300px">
              </app-rich-text-editor>
              <div *ngIf="news_description?.invalid && news_description?.touched" class="invalid-feedback d-block">
                <div *ngIf="news_description?.errors?.['required']">News description is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading || isUploading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
